module.exports = __webpack_public_path__ + "assets/img/af73-me.svg";